import Blueprint from './blueprint';
import LegalInformation from './legal-information';
import LicenseInformation from './license-information';
import MainContent from './main-content';
import PaymentProcess from './payment-process';
import ProjectLocation from './project-location';
import RealEstateInProject from './real-estate-in-project';
import Utilities from './utilities';
import dynamic from 'next/dynamic';

const LoanEstimation = dynamic(() => import('./loan-estimation'), { ssr: false });

const MainSectionLeft = () => (
  <div className='m-[-8px] flex flex-1 flex-col space-y-[24px] overflow-x-hidden p-[8px]'>
    <MainContent />
    <RealEstateInProject />
    <LicenseInformation />
    <LegalInformation />
    <ProjectLocation />
    <Utilities />
    <Blueprint />
    <PaymentProcess />
    <LoanEstimation />
  </div>
);

export default MainSectionLeft;
